import React from 'react';
import { QuerySetContextProvider } from '~/contexts/QuerysetContext';
import { LoadMore } from '~/core/useSearchState';
import { useCategoryResults } from '~/hooks/useCategoryResults';
import { GoToResultHandler } from '~/hooks/useGoToResult';
import { CategoryList } from './CategoryList';

export interface ICategoriesProps {
    handleGoToResult: GoToResultHandler;
    loadMore: LoadMore;
}

const Categories: React.FC<ICategoriesProps> = ({ loadMore }) => {
    const { categoryResults } = useCategoryResults();

    return (
        <div data-testid="categories">
            {categoryResults
                .filter(
                    (categoryResult) =>
                        categoryResult.result.totalRecords > 0 || categoryResult.state.setting.showZeroResults
                )
                .map((categoryResult) => (
                    <QuerySetContextProvider
                        key={categoryResult.result.querySetIdentifier}
                        state={categoryResult.state}
                        querySetId={categoryResult.result.querySetIdentifier}
                    >
                        <CategoryList categoryResult={categoryResult} loadMore={loadMore} />
                    </QuerySetContextProvider>
                ))}
        </div>
    );
};

export default Categories;
